module.exports = __webpack_public_path__ + "static/fonts/wizard.75597bce.eot";